import { cloneDeep } from 'lodash-es';

// 简单的模块级缓存，用于暂存被移除的 AOD Theme
// 提供基本的增/删/查/清理操作，缓存值为深拷贝，避免外部修改污染
const _cache: Record<string, StoreThemeItem> = {};

export const setRemovedAOD = (name: string, theme: StoreThemeItem) => {
  _cache[name] = cloneDeep(theme);
};

export const getRemovedAOD = (name: string): StoreThemeItem | undefined => {
  const item = _cache[name];
  return item ? cloneDeep(item) : undefined;
};

export const hasRemovedAOD = (name: string): boolean => {
  return !!_cache[name];
};

export const deleteRemovedAOD = (name: string) => {
  delete _cache[name];
};

export const clearRemovedAOD = () => {
  Object.keys(_cache).forEach((k) => delete _cache[k]);
};

export const listRemovedAOD = (): string[] => {
  return Object.keys(_cache);
};

export default {
  setRemovedAOD,
  getRemovedAOD,
  hasRemovedAOD,
  deleteRemovedAOD,
  clearRemovedAOD,
  listRemovedAOD
};
